
import Vue from 'vue'

import AttributeSelector from './AttributeSelector.vue'
import { variant, updateAttribute, attributeEnum, productToAdd } from '@/types'

export default Vue.extend({
  name: 'ProductTile',
  props: {
    productInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    AttributeSelector
  },
  data() {
    return {
      attributeEnum,
      fabricSelected: '',
      sizeSelected: ''
    }
  },
  computed: {
    selectedVariant(): variant {
      return this.productInfo.variants.filter((variant: variant) => {
        return (
          variant.attributes[0].value === this.sizeSelected &&
          variant.attributes[1].value === this.fabricSelected
        )
      })[0]
    },
    sizeOptions() {
      const result: string[] = []

      this.productInfo.variants.forEach((variant: variant) => {
        if (result.includes(variant.attributes[0].value)) return

        result.push(variant.attributes[0].value)
      })
      return result
    },
    fabricOptions() {
      const result: string[] = []

      this.productInfo.variants.forEach((variant: variant) => {
        if (result.includes(variant.attributes[1].value)) return

        result.push(variant.attributes[1].value)
      })
      return result
    },
    defaultVariantIndex(): number {
      return this.productInfo.variants.findIndex((variant: variant) => {
        return variant.id === this.productInfo.defaultVariantId
      })
    }
  },
  methods: {
    updateAttribute({ attribute, value }: updateAttribute): void {
      if (attribute === attributeEnum.SIZE) this.sizeSelected = value
      if (attribute === attributeEnum.FABRIC) this.fabricSelected = value
    },
    addToCart() {
      const productToAdd: productToAdd = {
        description: this.selectedVariant.name,
        image: this.productInfo.image,
        name: this.productInfo.name,
        price: this.selectedVariant.price,
        productId: this.productInfo.id,
        variantId: this.selectedVariant.id
      }
      this.$store.commit('addToCart', productToAdd)
    }
  },
  created() {
    const index = this.defaultVariantIndex
    if (!this.productInfo.variants[index]) return

    this.sizeSelected = this.productInfo.variants[index].attributes[0].value
    this.fabricSelected = this.productInfo.variants[index].attributes[1].value
  }
})
